const toolConfig = {
  lex: {
    errorMsg: "呃…页面加载失败啦，请刷新后再试一次。",
  },
  livechatwelcomemsg: "我是 <agentName>",
  surveyprompt: "请选择一个评分",
  assist: { switch: "on" },
  assistApi: "https://s.vodafone.co.nz/",
  tray: {
    contentlist: {
      list1: {
        title: "条款与条件",
        content:
          "<p class='tray-notice'>我们会收集您的信息，用于身份验证及协助处理您的咨询。详情请参阅我们的《隐私政策》和《条款与条件》。</p><a href='https://one.nz/legal/policy/privacy/' class='link-text open-in-tray'>隐私政策</a><a href='https://one.nz/legal/terms-conditions/ai-assistant-agent/' class='link-text open-in-tray'>条款与条件</a>",
      },
    },
  },
  sales: {
    urlList: [
      "/specials-promos/",
      "/iphone/iphone-12-pro-max/",
      "/broadband/",
      "/broadband/internet-plans/",
      "/broadband/internet-plans/plan-options/",
      "/broadband/rural/",
      "/home-wireless-broadband/",
      "/broadband/moving-home/",
      "/broadband/ultra-fast-fibre/",
      "/mobile-broadband/",
      "/broadband/ultrahub-modem/",
      "/broadband/what-can-i-get/",
      "/mobile-broadband/pocket-wifi/",
      "/help/broadband-and-tv/modem-support/",
      "/business/wireless-broadband/",
    ],
    autoOpenTime: "15",
    salesLiveIntent: "sales.on_web",
    weekdaysHours: "7-24",
    salesLeaveIntent: "sales.on_web_closed",
    weekendsHours: "9-18",
  },
};

export default toolConfig;
